

import { TVChartContainerLine } from '../../components/TVChartContainer/TVcontainer_line';
import { useState, useEffect, useMemo, useRef } from "react";
// import { makeApiRequest } from "../../mydatafeed/helpers";
import { API_URL } from "../../api-config";
import './dashboard.css';
import axios from "axios";
require('jstat') 

const Dashboard = () => {
  const widgetRef = useRef(null);
  const [, setShowButton] = useState(window.innerWidth <= 768);
  const [isFullScreen, setIsFullScreen] = useState(false);

  const handleNewTick = (tickData) => {
    setPrice(tickData.price);
  };

  const updatePrice = async () => {
    try {
      // const response = await makeApiRequest(`${API_URL}/last_price`);
      let data;
      const token = localStorage.getItem("token");
      await axios.get(`${API_URL}/trading-api/historical/ticks/2`,{
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((response) => {
        data = response.data;
        console.log(data)
      })

      if (data && data && data[0]) {
        setPrice(data[0].Precio);
      } else {
        console.error("No se pudo obtener el precio del dólar");
      }
    } catch (error) {
      console.error("Error al actualizar el precio del dólar:", error);
    }
  };



  useEffect(() => {
    const handleResize = () => {
      setShowButton(window.innerWidth <= 768);
    };
  
    const handleFullScreenChange = () => {
      if (document.fullscreenElement) {
        setIsFullScreen(true);
      } else {
        setIsFullScreen(false);
      }
    };

    window.updateDashboardData = handleNewTick;
    window.addEventListener('resize', handleResize);
    document.addEventListener('fullscreenchange', handleFullScreenChange);

    return () => {
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('fullscreenchange', handleFullScreenChange);
      window.updateDashboardData = null;
    };
  }, []);



  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        await updatePrice();


        
      } catch (error) {
        console.error("Error fetching initial data", error);
      }
    };
    fetchInitialData();
    updatePrice()
    const volumeInterval = setInterval(updatePrice, 120000);

    return () => {
      clearInterval(volumeInterval);
    };
  }, []);

  const [price, setPrice] = useState(0);


  const rotationStyles = isFullScreen 
    ? { transform: "rotate(-90deg)", width: "100vh", height: "100vw", overflow: "scroll", position: "absolute", top: "100%", left: "0" } 
    : {};
  const fullScreenStyles = isFullScreen
    ? { width: '90%', height: '90%', position: 'fixed', top: 0, left: 0, zIndex: 5000, margin: 0, padding: 0 }
    : {};

  const TVChart = useMemo(() => (
    <div className='widget-div' ref={widgetRef} style={{ ...rotationStyles, ...fullScreenStyles }}>
      <TVChartContainerLine />
    </div>
  ), []);
  
  return (
    <div className="py-6 md:p-4  flex flex-col">
      <div className="w-auto flex flex-row  pl-2 pr-2">
          <h1 className = "text-4xl dolar">{`USDCLP: ${price}`}</h1>
      </div>
      <div className="flex justify-center md:w-full p-1  w-screen px-6 mb-12 pt-2"   ref={widgetRef} style={{ ...rotationStyles, ...fullScreenStyles }}>
        {TVChart}
      </div>
    
    </div>
  );
};

export default Dashboard;